<template>
  <div class="app-container" :class="{ 'light-mode': !darkMode }">
    <Header />
    <VerifyIdentityBanner />
    <main class="main-content">
      <router-view></router-view>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import VerifyIdentityBanner from "./components/VerifyIdentityBanner.vue";
import { mapState } from "vuex";

export default {
  components: {
    Header,
    Footer,
    VerifyIdentityBanner,
  },
  computed: {
    ...mapState(['darkMode']),
  },
  // methods: {
  //   getUserLocation() {
  //     if ("geolocation" in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           const location = {
  //             latitude: position.coords.latitude,
  //             longitude: position.coords.longitude,
  //             error: null,
  //           };
  //           this.updateUserLocation(location);
  //         },
  //         (error) => {
  //           const location = {
  //             latitude: null,
  //             longitude: null,
  //             error: error.message,
  //           };
  //           this.updateUserLocation(location);
  //           console.error("Error getting location:", error.message);
  //         }
  //       );
  //     } else {
  //       const location = {
  //         latitude: null,
  //         longitude: null,
  //         error: "Geolocation is not supported by your browser",
  //       };
  //       this.updateUserLocation(location);
  //       console.error("Geolocation is not supported by your browser");
  //     }
  //   },
  // },
};
</script>

<style>
:root {
  /* Dark mode colors (default) */
  --primary-color: #2c0f54;
  --secondary-color: #e91e63;
  --accent-color: #ffd700;
  --background-dark: #1a1a2e;
  --background-color: #1a1a2e;
  --text-light: #fdfdfd;
  --text-color: #fdfdfd;
  --card-background: #252541;
  --header-gradient-start: #2c0f54;
  --header-gradient-end: #4a1f8a;
  --input-background: rgba(255, 255, 255, 0.1);
  --input-border: rgba(255, 255, 255, 0.1);
  --input-placeholder: rgba(253, 253, 253, 0.5);
  --muted-field-background: rgba(255, 255, 255, 0.05);
  --muted-field-color: #ffd700;
}

/* Light mode colors */
.light-mode {
  --primary-color: #2c0f54;
  --secondary-color: #e91e63;
  --accent-color: #ff8c00;
  --background-color: #ffffff;
  --text-color: #2a2a2a;
  --card-background: #ffffff;
  --header-gradient-start: #4a1f8a;
  --header-gradient-end: #6a3faa;
  --input-background: #f4f4f7;
  --input-border: rgba(0, 0, 0, 0.12);
  --input-placeholder: rgba(42, 42, 42, 0.55);
  --muted-field-background: #ededf2;
  --muted-field-color: #8a4b00;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--background-color);
  color: var(--text-color);
  font-family: "Arial", sans-serif;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.app-container {
  min-height: 100vh;
  background-color: var(--background-color);
  color: var(--text-color);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.main-content {
  padding: 2rem;
  padding-bottom: 4rem; /* Space for fixed footer */
  min-height: calc(100vh - 200px); /* Adjust based on header/footer height */
}

/* Mobile responsive styles for main layout */
@media (max-width: 768px) {
  body {
    font-size: 14px;
    line-height: 1.5;
  }

  .app-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    padding: 1rem;
    padding-bottom: 5rem; /* More space for mobile footer */
    flex: 1;
    min-height: auto;
  }
}

@media (max-width: 480px) {
  body {
    font-size: 13px;
  }

  .main-content {
    padding: 0.75rem;
    padding-bottom: 5.5rem;
  }
}

/* Very small screens */
@media (max-width: 360px) {
  body {
    font-size: 12px;
  }

  .main-content {
    padding: 0.5rem;
    padding-bottom: 6rem;
  }
}

/* Landscape mobile orientation */
@media (max-width: 768px) and (orientation: landscape) {
  .main-content {
    padding: 0.8rem;
    padding-bottom: 4rem;
    min-height: calc(100vh - 120px);
  }
}

/* High DPI screens (Retina, etc.) */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

/* Touch device optimizations */
@media (hover: none) and (pointer: coarse) {
  /* Increase touch target sizes */
  button,
  .nav-link,
  .action-btn {
    min-height: 44px;
    min-width: 44px;
  }

  /* Improve tap highlighting */
  * {
    -webkit-tap-highlight-color: rgba(255, 215, 0, 0.3);
  }
}

/* Dark theme support (system preference) */
@media (prefers-color-scheme: dark) {
  /* Already using dark theme, but can add overrides if needed */
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  *,
  ::before,
  ::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>
